module.exports = __webpack_public_path__ + "img/infrasel_3.861cc91f.png";